import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Slot } from '@ils/slots/db/slot.js';
import { ILSUser } from '@legacy-db/ils-user.js';

@Entity()
export class InspectorOverviewLine extends AdornisEntity {
  static override _class = 'InspectorOverviewLine';

  static override resolveID(entity: any): string {
    return entity.slot._id;
  }

  @Field(type => Slot)
  slot!: Slot;

  @Field(type => ILSUser)
  coInspector?: Maybe<ILSUser>;
}
